import { NewsContentType } from '@/types/enum';

export default {
  id: '20220803', //  模块 id
  title: '叮咚买菜联合原产地打造国内首个现代化“梭子蟹产地仓”', // 标题
  origin: '2022-08-03 17:35 来源：新京报', // 新闻来源
  editor: '记者 张洁 编辑 王琳', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '新京报讯（记者张洁）8月3日，岱山县政府、叮咚买菜与舟山市中浩水产食品公司共同参与了“叮咚买菜舟山梭子蟹基地”的挂牌仪式，首个“叮咚岛”正式落地舟山。该产地仓投资1.5亿元，有84个暂养池，可同时容纳30万斤梭子蟹的暂养需求。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '为让更多消费者品尝到带着海水鲜味的鲜活梭子蟹，今年，叮咚买菜联合原产地，打造了国内首个现代化“梭子蟹产地仓”。据介绍，梭子蟹十分娇贵，一旦脱离海水环境，不做充氧制冷措施，很快就会死亡。叮咚的“产地仓”距离码头只有500米，梭子蟹在离开海洋的数分钟之内就住进了“海景别墅”：通过24小时循环过滤净化的原生海水，模拟潮汐的环境，恒定的温度，池底铺设的海沙，模拟梭子蟹在海里的原生生长环境。同时，冷链运输采用“海水循环恒温车”，直接送往全国各大城市的前置仓，直到最后送到用户手中的最后一公里，全程低温冷链。“海洋特快”使得叮咚买菜梭子蟹的存活率从80%提升到90%。',
    }, 
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '对于“产地仓”的落地，叮咚买菜方面介绍，一是加固供应链的稳定性，梭子蟹都是海洋捕捞，而不是养殖，货源的不稳定性很强，比如遇到台风等天气会断货，并且价格高昂，通过产地仓不仅在货源上能够解决全国范围的需求，还能稳定市场价格；二是提高品质和食品安全的确定性，叮咚买菜引入了全球领先的第三方检测机构——Intertek，整个产季驻守“产地仓”，每天对所有批次的梭子蟹进行检测，非达标商品零容忍，打造水产行业最严安全与品质标准。',
    },
    {
      type: 2,
    },   
    {
      type: NewsContentType.Text,
      text:
        '据叮咚买菜华北水产相关负责人介绍，叮咚买菜第一批梭子蟹将于8月3日晚到达北京，4日上线售卖',
    },   
      
  ],
};
